import { Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CookieConsentComponent } from 'src/app/components/cookie-consent/cookie-consent.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.' + environment.brand + '.html',
    styleUrls: ['./footer.component.' + environment.brand + '.css'],
    providers: [DialogService]
})
export class FooterComponent {
    constructor(private dialogService: DialogService) { }

    scrollToTop(): void {
        window.scroll(0, 0);
    }

    showCookieConsentDialog(): void {
        this.dialogService.open(CookieConsentComponent, {
            width: '60%',
            showHeader: false,
            baseZIndex: 10000,
            closable: false,
            closeOnEscape: false
        });
    }
}
